import { z } from "zod";

/** Charge line in expanded quote details (rate quote review service cards). */
const rateQuoteReviewAdditionalServiceSchema = z.object({
  id: z.number(),
  title: z.string(),
  charge: z.string(),
});

const rateQuoteReviewStandardTierSchema = z.object({
  quoteId: z.string(),
  totalAmount: z.string(),
});

const rateQuoteReviewPremiumTierSchema = z.object({
  quoteId: z.string(),
  totalAmount: z.string(),
  guaranteedService: z.string(),
});

/** Pricing breakdown shared across LTL / UC / Volume cards on rate quote review. */
export const rateQuoteReviewPricingDetailsSchema = z.object({
  grossCharge: z.string(),
  discountAmount: z.string(),
  discountPercent: z.string(),
  freightCharges: z.string(),
  fuelSurcharge: z.string(),
  additionalServices: z
    .array(rateQuoteReviewAdditionalServiceSchema)
    .optional(),
  standard: rateQuoteReviewStandardTierSchema,
  guaranteed: rateQuoteReviewPremiumTierSchema,
  volume: rateQuoteReviewPremiumTierSchema,
});

const rateQuoteReviewServiceCardKeySchema = z.enum(["ltl", "uc", "volume"]);

const rateQuoteReviewServiceCardConfigSchema = z.object({
  key: rateQuoteReviewServiceCardKeySchema,
  serviceDisplayName: z.string(),
  quoteId: z.string(),
  totalAmount: z.string(),
  showRecommendedBadge: z.boolean(),
  showSpeedIcon: z.boolean(),
  showTruckIcon: z.boolean(),
  includeGuaranteedServiceLine: z.boolean(),
  collapsedPriceAddon: z.string().optional(),
  guaranteedServiceChargeDisplay: z.string().optional(),
});

export const rateQuoteReviewServiceCardsSchema = z.array(
  rateQuoteReviewServiceCardConfigSchema
);

export type RateQuoteReviewPricingDetails = z.infer<
  typeof rateQuoteReviewPricingDetailsSchema
>;

export type RateQuoteReviewServiceCardConfig = z.infer<
  typeof rateQuoteReviewServiceCardConfigSchema
>;
